import { projectFirestore } from "@/firebase/config";
import { collection, getDocs, query, where } from "firebase/firestore";

const checkExistData = async (data, valueCheck) => {


  let awaitData = [];
  data.forEach((cb) => {
    if (cb.collection && cb.field) {
      let path = cb.collection;
      if (valueCheck) {
        awaitData.push(
          getDocs(query(collection(projectFirestore, path), where(cb.field, "==", valueCheck)))
        );
      }
    }
  });
  const existData = await Promise.all(awaitData);


  let result = 0;
  for (const key in existData) {
    let data = existData[key].docs.length;
    console.log("data", data)
    if (data) {
      result = data;
      break;
    }
  }

  console.log("result check", result);
  return result;
};

export default checkExistData;
